import React from "react";

const CreditDocumentTooltip = ({ t }) => (
    <div>
        <div><strong>{t("contents.alerts.document_tooltip.title")}</strong></div>
        <br/>

        <div><strong>1. {t("contents.alerts.document_tooltip.chargeback_received")}</strong></div>
        <div>{t("contents.alerts.document_tooltip.card_number")}</div>
        <div>{t("contents.alerts.document_tooltip.transaction_amount_date_time")}</div>
        <div>{t("contents.alerts.document_tooltip.chargeback_date_time")}</div>
        <div>{t("contents.alerts.document_tooltip.refund_amount_date_time")}</div>
        <br/>

        <div><strong>2. {t("contents.alerts.document_tooltip.previously_refunded")}</strong></div>
        <div>{t("contents.alerts.document_tooltip.card_number")}</div>
        <div>{t("contents.alerts.document_tooltip.transaction_amount_date_time")}</div>
        <div>{t("contents.alerts.document_tooltip.refund_void_amount_date_time")}</div>
        <br/>

        <div><strong>3. {t("contents.alerts.document_tooltip.declined_transaction")}</strong></div>
        <div>{t("contents.alerts.document_tooltip.card_number")}</div>
        <div>{t("contents.alerts.document_tooltip.transaction_amount_date_time")}</div>
        <div>{t("contents.alerts.document_tooltip.decline_message")}</div>
        <br/>

    </div>
);

export default CreditDocumentTooltip;
